import React from "react";
import { Link } from "gatsby";
import { Container, Row, Col } from "react-bootstrap";
import styled from "styled-components";

import { INK } from "./tokens";
import { SCANNING_PHONE, SCANNING_PHONE_HREF } from "./contact";
import EmailReveal from "../../components/EmailReveal";
import { aiTaggingPrice } from "./prices";
import DevProOwnership from "./DevProOwnership";

// The scanning section's own footer. Mail gets one line here, under Also from
// HotSnail, and that is the only route from scanning back to the mail site
// besides the cross-sell block on the overview page.
const Foot = styled.footer`
  background: ${INK};
  color: #94a3b8;
  padding: 48px 0 32px;

  a {
    color: #94a3b8;
    text-decoration: none;
    font-size: 15px;

    &:hover {
      color: #ffffff;
      text-decoration: none;
    }
  }

  h2 {
    font-size: 13px;
    letter-spacing: 1.1px;
    text-transform: uppercase;
    color: #ffffff;
    font-weight: 600;
    margin-bottom: 14px;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
`;

const Mark = styled.div`
  font-weight: 700;
  font-size: 18px;
  color: #ffffff;
  margin-bottom: 8px;
`;

const Base = styled.div`
  border-top: 1px solid #1e293b;
  margin-top: 36px;
  padding-top: 22px;
  font-size: 14px;
`;

const ScanFooter = () => (
  <Foot>
    <Container>
      <Row>
        <Col lg="4" className="mb-5 mb-lg-0">
          <Mark>HotSnail Document Scanning</Mark>
          <p style={{ margin: 0, fontSize: "14px", lineHeight: 1.6 }}>
            Document scanning on the Gold Coast and in Brisbane. Part of
            HotSnail, handling Australians&rsquo; confidential paper since 2009.
          </p>
          <p className="mt-3 mb-0"><a href={SCANNING_PHONE_HREF}>Call {SCANNING_PHONE}</a></p>
          <div className="mt-2"><EmailReveal /></div>
          <div className="mt-3"><DevProOwnership /></div>
        </Col>
        <Col xs="6" lg="3" className="mb-4 mb-lg-0">
          <h2>Service</h2>
          <ul>
            <li>
              <Link to="/document-scanning/pricing/">Pricing</Link>
            </li>
            <li>
              <Link to="/document-scanning/how-it-works/">How it works</Link>
            </li>
            <li>
              <Link to="/document-scanning/ai-indexing/">AI indexing</Link>
            </li>
            <li><Link to="/document-scanning/security/">Security &amp; data</Link></li>
            <li><Link to="/document-scanning/custom-workflows/">Custom workflows</Link></li>
            <li><Link to="/document-scanning/case-study/">Work-order workflow</Link></li>
            <li><Link to="/document-scanning/digital-mailroom/">Digital mailroom</Link></li>
            <li><Link to="/document-scanning/data-conversion/">Data conversion</Link></li>
          </ul>
          <h2 className="mt-4">Guides</h2>
          <ul>
            <li><Link to="/document-scanning/outsourcing-checklist/">Outsourcing checklist</Link></li>
            <li><Link to="/document-scanning/what-is-ocr/">What is OCR?</Link></li>
            <li><Link to="/document-scanning/scan-file-formats/">PDF, PDF/A or TIFF</Link></li>
          </ul>
        </Col>
        <Col xs="6" lg="2" className="mb-4 mb-lg-0">
          <h2>Locations &amp; industries</h2>
          <ul>
            <li>
              <Link to="/document-scanning/gold-coast/">Gold Coast</Link>
            </li>
            <li>
              <Link to="/document-scanning/brisbane/">Brisbane</Link>
            </li>
            <li><Link to="/document-scanning/legal/">Legal scanning</Link></li>
            <li><Link to="/document-scanning/medical/">Medical records</Link></li>
            <li><Link to="/document-scanning/accountants-financial-planners/">Accountants</Link></li>
            <li><Link to="/document-scanning/invoice-scanning/">Invoices</Link></li>
            <li><Link to="/document-scanning/employee-records/">HR records</Link></li>
            <li><Link to="/document-scanning/contract-scanning/">Contracts</Link></li>
          </ul>
        </Col>
        <Col lg="3">
          <h2>Also from HotSnail</h2>
          <ul>
            <li>
              <a href="/">Mail scanning</a>
            </li>
            <li>
              <a href="/contact-us/">Contact us</a>
            </li>
            <li>
              <a href="/privacy/">Privacy</a>
            </li>
          </ul>
        </Col>
      </Row>
      <Base><p>OCR included. Optional AI metadata tagging {aiTaggingPrice}. AUD, excluding GST. <Link to="/document-scanning/pricing/">See pricing</Link>.</p>&copy; {new Date().getFullYear()} HotSnail. All rights reserved.</Base>
    </Container>
  </Foot>
);

export default ScanFooter;
